import { Platform } from 'react-native';
import { PROVIDER_GOOGLE } from 'react-native-maps';
import type { MapViewProps } from 'react-native-maps';

/**
 * Which map engine draws every `MapView` in the app.
 *
 * ---------------------------------------------------------------------------
 * APPLE MAPS ON iOS, GOOGLE MAPS ON ANDROID
 * ---------------------------------------------------------------------------
 * `react-native-maps` picks its engine from this one prop, and leaving it
 * undefined does not mean "no map" - it means the platform's own: MapKit on
 * iOS, Google Maps on Android. So `undefined` IS the Apple Maps setting, and
 * there is no `PROVIDER_APPLE` to pass instead.
 *
 * ---------------------------------------------------------------------------
 * WHY THIS IS NOT MERELY A PREFERENCE
 * ---------------------------------------------------------------------------
 * Both maps used to pass `PROVIDER_GOOGLE` on every platform, and on iOS that
 * asks for an engine this app does not ship. Google Maps on iOS is a separate
 * SDK: it needs the `GoogleMaps` pod and a `GMSServices.provideAPIKey` call in
 * `AppDelegate`, and the project has neither - no pod in the Podfile or
 * Podfile.lock, no key anywhere. The result is a `MapView` that mounts, takes
 * up its space and renders nothing: the location screen and the ride tracker
 * were both showing a blank rectangle on iPhone.
 *
 * Android keeps `PROVIDER_GOOGLE`. It is already the platform default there,
 * and stating it keeps the two branches symmetrical and this comment findable
 * from both call sites.
 *
 * If Google Maps on iOS is ever actually wanted, adding the constant back is
 * the smallest part of it - the pod, the API key and its restrictions are the
 * work, and until all three exist this must not be changed.
 */
export const MAP_PROVIDER: MapViewProps['provider'] = Platform.select({
  ios: undefined,
  default: PROVIDER_GOOGLE,
});
